export default "__VITE_ASSET__ac4dd67f__"